import { render, staticRenderFns } from "./Calendars.vue?vue&type=template&id=c24de5fe"
import script from "./Calendars.vue?vue&type=script&lang=js"
export * from "./Calendars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports